import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Sparen {{percentageAmount}}% auf ausgewählte Artikel',
    description:
      'Sparen {{percentageAmount}}% auf Ihre Bestellung, wenn ausgewählte Artikel bestellen. Das Angebot ist gültig{{fromTo}}, bis das maximale Limit für Aktionen erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% Rabatt ab {{minSpendValue}}',
    description:
      'Sparen {{percentageAmount}}% auf Ihre Bestellung. Das Angebot ist gültig{{fromTo}}, bis das maximale Limit für Aktionen erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Sparen {{amount}} auf ausgewählte Artikel',
    description:
      'Sparen {{amount}}, wenn ausgewählte Artikel bestellen. Das Angebot ist gültig{{fromTo}}, bis das maximale Limit für Aktionen erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Sparen {{amount}} ab {{minSpendValue}}',
    description:
      'Sparen {{amount}} bei einem Bestellwert. Das Angebot ist gültig{{fromTo}}, bis das maximale Limit für Aktionen erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.Bogo]: {
    title: '2 für den Preis von 1 kaufen!',
    description:
      'Kaufen einen Artikel und erhalten den zweiten Artikel kostenlos. Das Angebot ist gültig{{fromTo}}, bis das Aktionslimit erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
    qualifying_items_description:
      'Wähle die Artikel aus, die der Kunde bestellen muss, um den kostenlosen Artikel zu erhalten.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Eins kaufen, eins zum halben Preis!',
    description:
      'Kaufen einen Artikel und erhalten den zweiten Artikel zum halben Preis. Das Angebot ist gültig{{fromTo}}, bis das Aktionslimit erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
    qualifying_items_description:
      'Wählen die Artikel aus, die der Kunde bestellen muss, um den kostenlosen Artikel zu erhalten.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Kostenloser Artikel bei einem Bestellwert',
    description:
      'Erhalten einen kostenlosen Artikel, wenn die Angebotsbedingungen erfüllen. Das Angebot ist gültig{{fromTo}}, bis das Aktionslimit erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
    reward_items_description:
      'Wählen den kostenlosen Artikel (oder die Artikel), aus denen der Kunde einen auswählen kann.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Kostenloser Artikel bei Ihrer Bestellung',
    description:
      'Erhalten einen kostenlosen Artikel, wenn die Angebotsbedingungen erfüllen. Das Angebot ist gültig{{fromTo}}, bis das Aktionslimit erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
    qualifying_items_description:
      'Wählen die Artikel aus, die der Kunde bestellen muss, um den kostenlosen Artikel zu erhalten.',
    reward_items_description:
      'Wählen den kostenlosen Artikel (oder die Artikel), aus denen der Kunde einen auswählen kann.',
  },
};

export default {
  offers,
  from_to: ' vom {{startsAt}} bis {{endsAt}} oder',
  qualifying_items_title: 'Qualifizierte Artikel',
  reward_items_title: 'Kostenlose Artikel',
  buttons: {
    add: 'Hinzufügen',
  },
};
